import styled from 'styled-components';

import { Text } from '../../../../cdl/Text/Text';
import { translate } from '../../../../common/helpers/translate.helper';
import { Box } from '../../../../common/ui/Box';
import { theme } from '../../../../common/ui/theme';
import { ScheduleLayout } from '../scheduleLayout';

import { ScheduleItem } from './ScheduleProductCard';
import { ScheduleStop } from './ScheduleStop';

const ColumnHeader = styled.div`
    width: ${ScheduleLayout.CARD_WIDTH};
    height: ${ScheduleLayout.HEADER_HEIGHT};
    border: 1px solid ${theme.colors.border.muted};
    border-radius: ${theme.radii[6]};
    display: flex;
    align-items: center;
    padding-left: ${theme.space[12]};
    padding-right: ${theme.space[12]};
    background-color: ${theme.colors.background.default};
    box-shadow: ${theme.shadows.medium};
`;

interface SchedulePortColumnProps {
    scheduleList: ScheduleItem[];
    firstStopIsCurrentStop: boolean;
}

export const SchedulePortColumn = ({ scheduleList, firstStopIsCurrentStop }: SchedulePortColumnProps) => {
    return (
        <Box
            width={ScheduleLayout.CARD_WIDTH}
            zIndex={100}
            position="relative"
            display="flex"
            flexDirection="column"
            gap={ScheduleLayout.ROW_GAP}
        >
            <ColumnHeader>
                <Text variant="body" fontWeight={600}>
                    {translate('schedule.portCall')}
                </Text>
            </ColumnHeader>

            {scheduleList.map((scheduleItem, index) => (
                <ScheduleStop
                    key={index}
                    stop={scheduleItem.stop}
                    vesselId={scheduleItem.vesselId}
                    index={index}
                    totalStops={scheduleList.length}
                    firstStopIsCurrentStop={firstStopIsCurrentStop}
                />
            ))}
        </Box>
    );
};
